<template>
  <div id="form-main">
    <div v-if="activeStep !== null">
      <StepComponent
        :value="form"
        @submit="nextStep($event, steps[activeStep])"
        :id="steps[activeStep]"
        :lastStep="lastStep"
      />
    </div>
    <div v-else id="form-loader">
      <div
        class="spinner-border"
        style="width: 10rem; height: 10rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <form
      ref="leadForm"
      id="rmk-form"
      action="/wp-admin/admin-post.php"
      method="post"
    >
      <input type="hidden" name="action" value="lead_submit" />
      <input
        type="hidden"
        name="mortgage_balance"
        v-model="form.mortgageBalance"
      />
      <input type="hidden" name="full_name" v-model="form.fullname" />
      <input type="hidden" name="age" v-model="form.age" />
      <input type="hidden" name="phone" v-model="form.phone" />
      <input type="hidden" name="email" v-model="form.email" />
      <input type="hidden" name="property_value" v-model="form.propertyValue" />
      <input type="hidden" name="full_address" v-model="address.fullAddress" />
      <input type="hidden" name="street_no" v-model="address.streetNo" />
      <input type="hidden" name="street_name" v-model="address.streetName" />
      <input type="hidden" name="city" v-model="address.city" />
      <input type="hidden" name="state" v-model="address.state" />
      <input type="hidden" name="zipcode" v-model="address.zipcode" />
      <input type="hidden" name="referrer" v-model="referrer" />
      <input type="hidden" name="query_params" v-model="queryString" />
      <input type="hidden" name="lead_source" id="lead_source" />
      <input type="hidden" name="redirect_path" v-model="redirectPath" />
      <input type="hidden" name="_token" v-model="csrf" />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import StepComponent from "./components/StepComponent.vue";

export default {
  name: "App",
  props: {
    cid: {
      default() {
        return "495";
      },
    },
    redirectPath: {
      type: String,
      default() {
        return "thank-you";
      },
    },
  },
  components: {
    StepComponent,
  },
  data() {
    return {
      activeStep: 0,
      steps: [
        "address",
        "fullname",
        "phone",
        "age",
        "propertyValue",
        "mortgageBalance",
      ],
      urlParams: [],
      form: {
        fullname: null,
        mortgageBalance: null,
        age: null,
        phone: null,
        email: null,
        propertyValue: null,
        address: null,
        previousLtv: null,
        jumboQual: null,
        statusId: null,
        rmQualified: null,
        homeEquityLoanBalance: null,
        finishedStep: null,
        skipHomeValue: false,
        skipMortgageBalance: false,
        skipAge: false,
      },
      address: {
        fullAddress: "",
        streetNo: null,
        streetName: null,
        city: null,
        state: null,
        zipcode: null,
      },
      referrer: null,
      queryString: null,
      csrf: document.querySelector('meta[name="csrf-token"]').content,
    };
  },
  methods: {
    nextStep: async function (value, fieldId) {
      if (fieldId == "address") {
        for (let element in value) {
          if (element in this.address) {
            this.address[element] = value[element];
          }
        }
        this.form.address = this.address;
      } else {
        this.form[fieldId] = value;
      }
      if (fieldId == "fullname") {
        if (this.address.city && this.address.streetName) {
          this.getHomeValue();
        }
      }

      if (this.activeStep === this.steps.length - 1) {
        this.activeStep = null;
        this.submitForm();
      } else {
        if (this.steps[this.activeStep + 1] == "age" && this.form.skipAge) {
          this.activeStep++;
        }
        if (
          this.steps[this.activeStep + 1] == "propertyValue" &&
          this.form.skipHomeValue
        ) {
          this.activeStep++;
        }
        if (
          this.steps[this.activeStep + 1] == "mortgageBalance" &&
          this.form.skipMortgageBalance
        ) {
          this.activeStep++;
        }
        if (this.activeStep === this.steps.length - 1) {
          this.activeStep = null;
          this.submitForm();
        } else {
          this.form.finishedStep = this.activeStep;
          localStorage.setItem("form", JSON.stringify(this.form));
          // go to next step
          window.history.pushState({ formStep: this.activeStep }, "");
          // if next step is the property value and we already have estimated value then skip it
          this.activeStep++;
          window.updateProgressbar(this.activeStep);
        }
      }
    },
    onBackButton: function (backEvent) {
      if (backEvent.state && backEvent.state.formStep !== null) {
        let _activeStep = backEvent.state.formStep + 1;
        if (
          this.steps[_activeStep] == "mortgageBalance" &&
          this.form.skipMortgageBalance
        ) {
          _activeStep--;
        }
        if (
          this.steps[_activeStep] == "propertyValue" &&
          this.form.skipHomeValue
        ) {
          _activeStep--;
        }
        if (this.steps[_activeStep] == "age" && this.form.skipAge) {
          _activeStep--;
        }
        this.activeStep = _activeStep;
      } else {
        this.activeStep = 0;
      }
      window.updateProgressbar(this.activeStep);
    },
    submitForm: function () {
      // delete the local storage
      localStorage.clear();
      this.$nextTick(function () {
        this.$refs.leadForm.submit();
      });
    },
    getValue: function (id) {
      return this.form[id];
    },
    getHomeValue: function () {
      return axios
        .post(
          "/wp-admin/admin-ajax.php?action=get-home-value",
          {
            addr1: this.address.streetNo + " " + this.address.streetName,
            city: this.address.city,
            state: this.address.state,
            zipcode: this.address.zipcode,
            full_name: this.form.fullname,
            get_age: true,
          },
          {
            headers: {
              "X-CSRF-TOKEN": this.csrf,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.form.propertyValue = res.data.data.home_value;
            this.form.mortgageBalance = res.data.data.mortgage_balance;
            if (Number(res.data.data.age) > 61) {
              this.form.age = res.data.data.age;
              this.form.skipAge = true;
            }
            if (Number(this.form.propertyValue) > 0) {
              this.form.skipHomeValue = true;
            }
            if (Number(this.form.mortgageBalance) > 0) {
              this.form.skipMortgageBalance = true;
            }
          } else {
            console.log(res.data.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    mergeJsons(obj1 = {}, obj2 = {}) {
      let result = {};
      let key;

      for (key in obj1) {
        if (Object.prototype.hasOwnProperty.call(obj1, key)) {
          result[key] = obj1[key];
        }
      }

      for (key in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, key)) {
          result[key] = obj2[key];
        }
      }
      return result;
    },
    paramsToObject(entries) {
      let result = {};
      for (let [key, value] of entries) {
        if (value) {
          result[key] = value;
        }
      }
      return result;
    },
  },
  mounted() {
    window.addEventListener("popstate", this.onBackButton);
    if (localStorage.getItem("form")) {
      this.form = JSON.parse(localStorage.getItem("form"));
      if (this.form.address) {
        this.address = this.form.address;
      }
      for (let index = 0; index <= this.form.finishedStep; index++) {
        if (
          this.steps[index] == "mortgageBalance" &&
          this.form.skipMortgageBalance
        ) {
          continue;
        }
        if (this.steps[index] == "propertyValue" && this.form.skipHomeValue) {
          continue;
        }
        if (this.steps[index] == "propertyValue" && this.form.skipHomeValue) {
          continue;
        }
        let nextStepTitle = "step-" + index;
        window.history.pushState({ formStep: index }, nextStepTitle);
      }
      this.activeStep = this.form.finishedStep;
      if (this.activeStep < this.steps.length - 1) {
        if (
          this.steps[this.form.finishedStep + 1] == "propertyValue" &&
          this.form.skipHomeValue
        ) {
          this.activeStep += 2;
        } else {
          this.activeStep += 1;
        }
      }
      window.updateProgressbar(this.activeStep);
    }
    if (localStorage.getItem("referrer")) {
      this.referrer = localStorage.getItem("referrer");
    } else {
      if (document.referrer) {
        let referrer = document.referrer;
        this.referrer = referrer.match(/:\/\/(.[^/]+)/)[1];
        localStorage.setItem("referrer", this.referrer);
      }
    }
    // check if query params exists in the local storage
    if (localStorage.getItem("query_params")) {
      this.queryString = localStorage.getItem("query_params");
    }
    // check if url has query parameter
    if (window.location.search) {
      let queries_params = window.location.search.substring(1);
      let urlParams = new URLSearchParams(queries_params);
      let entries = urlParams.entries();
      let params_json = this.paramsToObject(entries);

      // check if query params exists in the local storage
      if (localStorage.getItem("query_params")) {
        // merge the existing one with the new one
        let existing_queries = JSON.parse(localStorage.getItem("query_params"));
        params_json = this.mergeJsons(existing_queries, params_json);
      }

      let queries_json_str = JSON.stringify(params_json);
      // store it in the local storage
      localStorage.setItem("query_params", queries_json_str);

      // set the querystring form field
      this.queryString = queries_json_str;
    }
  },
  unmounted() {
    document.removeEventListener("popstate", this.onBackButton);
  },
  computed: {
    lastStep() {
        // if phone and next 3 steps are skipped
        if (this.activeStep === this.steps.length - 4 && this.form.skipMortgageBalance && this.form.skipHomeValue && this.form.skipAge) {
            return true
        // if age next 2 steps are skipped
        } else if (this.activeStep === this.steps.length - 3 && this.form.skipMortgageBalance && this.form.skipHomeValue) {
            return true
        // if propertyvalue and mortgage balance is skipped
        } else if (this.activeStep === this.steps.length - 2 && this.form.skipMortgageBalance) {
            return true
        // if mortgage balance -> true
        } else if (this.activeStep === this.steps.length - 1) {
            return true
        } else {
            return false
        }
    }
  }

};
</script>